<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是标题和返回 -->
    <div class="title_box">
      <h4>{{ navigationTitle }}</h4>
      <el-button size="small" type="info" @click="backProject">返回</el-button>
    </div>
    <!-- 这里边是一个表单 -->
    <el-form ref="reference" :model="reference" size="small" label-width="80px" label-position="top" :rules="rules">
      <el-card class="box-card">
        <el-form-item label="专家姓名" prop="name">
          <el-col :span="13">
            <el-input v-model="reference.name" placeholder="请输入专家姓名"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-col :span="6">
            <el-input v-model="reference.phone" placeholder="请输入联系方式"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="专家照片" prop="photo">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="职称" prop="title">
          <el-col :span="5">
            <el-input v-model="reference.title" placeholder="请输入专家职称"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="所在医院" prop="hospital">
          <el-col :span="9">
            <el-input v-model="reference.hospital" placeholder="请输入所在医院"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="所属科室" prop="department">
          <el-select v-model="reference.department" placeholder="请选择" filterable>
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作简历" prop="resume">
          <el-col :span="24">
            <el-input type="textarea" v-model="reference.resume" placeholder="请输入工作简历"></el-input>
          </el-col>
        </el-form-item>
      </el-card>
      <el-card class="box-card">
        <el-form-item label="科研情况" prop="ky_info">
          <el-input type="textarea" :rows="2" placeholder="请输入科研情况" v-model="reference.ky_info">
          </el-input>
        </el-form-item>
        <el-form-item label="研究兴趣" prop="yj_info">
          <el-input type="textarea" :rows="2" placeholder="请输入研究兴趣" v-model="reference.yj_info">
          </el-input>
        </el-form-item>
        <el-form-item label="代表性论文" prop="paper">
          <!-- 这里是代表性论文 -->
          <div class="uploads-box">
            <el-upload class="upload-demo" :action="action" multiple :file-list="fileListLW" :on-success="thesisSuccess"
              :data="{ file: 'file', model: '' }" ref="thesis" :limit="1" v-model="reference.paper"
              :before-remove="beforeremoveLW">
              <el-button size="small" type="info">选择文件</el-button>
              <div class="box"></div>
            </el-upload>
            <span class="ticks">请上传TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、PDF
              等文件格式</span>
          </div>
        </el-form-item>
        <el-form-item label="学术任职" prop="learn_post">
          <el-input type="textarea" :rows="2" placeholder="请输入学术任职" v-model="reference.learn_post">
          </el-input>
        </el-form-item>
        <el-form-item label="参与共识" prop="part_in_consensus">
          <el-input type="textarea" :rows="2" placeholder="请输入参与共识" v-model="reference.part_in_consensus">
          </el-input>
        </el-form-item>
        <el-form-item label="附件">
          <!-- 这里是附件-->
          <div class="uploads-box">
            <el-upload class="upload-demo" :action="action" multiple :file-list="fileListFJ"
              :on-success="accessorySuccess" :data="{ file: 'file', model: '' }" ref="accessory" v-model="reference.enclosure"
              :limit="1" :before-remove="beforeremove">
              <el-button size="small" type="info">选择文件</el-button>
              <div class="box"></div>
            </el-upload>
            <span class="ticks">请上传TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、PDF
              等文件格式</span>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input v-model="reference.remarks" type="textarea" :rows="2" placeholder="请输入备注">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="background: #484c7f" @click="submitForm('reference')">保存</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'ExpertEditor',
  data() {
    return {
      options: [],
      navigationTitle: '录入专家',
      reference: {
        id: '', //主键id 有时修改 空时添加
        project_id: '', // 项目id，在编辑项目时录入专家时传递，信息库添加专家时不需要
        name: "", //姓名
        phone: "", //手机号
        photo: "", //照片
        title: "", //职称
        hospital: "", //医院
        department: "", //科室
        resume: "", //简历
        ky_info: "", //科研
        yj_info: "", //兴趣
        paper: "", //论文
        paper_name: '', //论文名称
        learn_post: "", //任职
        part_in_consensus: "", //共识
        enclosure: "", //附件
        remarks: "", //备注
        file_name: '', //附件名称
      },
      rules: {
        name: [{
          required: true,
          message: '请输入专家名称',
          trigger: 'blur'
        },],
        photo: [{
          required: true,
          message: '请上传图片',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入职称',
          trigger: 'blur'
        }],
        hospital: [{
          required: true,
          message: '请输入所在医院',
          trigger: 'blur'
        }],
        department: [{
          required: true,
          message: '请输入所属科室',
          trigger: 'change'
        }],
      },
      action: `https://laravel.gongshicloud.com/api/index/upload`,
      imageUrl: "",
      fileListLW: [],
      fileListFJ: [],
    }
  },
  created() {
    if (this.$route.query.id != "") this.compileEntry(this.$route.query.type, this.$route.query.id)
    if (this.$route.query.project_id != '' && this.$route.query.project_id != null && this.$route.query.project_id != undefined) this.reference.project_id = this.$route.query.project_id
    this.getSectionsList()
  },
  methods: {
    //点击编辑进来的
    async compileEntry(type, id) {
      this.navigationTitle = '编辑专家'
      const {
        data: data
      } = await this.$http.post("info/detail", {
        type,
        id
      })
      this.reference = data.data
      this.imageUrl = data.data.photo
      if (data.data.paper_name != "") this.fileListLW.push({
        name: data.data.paper_name,
        url: data.data.paper
      })
      if (data.data.file_name != "") this.fileListFJ.push({
        name: data.data.file_name,
        url: data.data.enclosure
      })
    },
    //获取科室
    async getSectionsList() {
      const {
        data: data
      } = await this.$http.post('cate/list', {
        type: '1'
      })
      this.options = data.data
    },
    //图片上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.imageUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.imageUrl = URL.createObjectURL(file.raw);
      this.reference.photo = res.data.url
    },
    //论文上传成功
    thesisSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$message.error(res.message)
        this.$refs.thesis.clearFiles()
        return
      }
      this.$Loading.finish()
      this.reference.paper = res.data.url
      this.reference.paper_name = res.data.file_name
    },
    //附件
    accessorySuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$message.error(res.message)
        this.$refs.accessory.clearFiles()
        return
      }
      this.$Loading.finish()
      this.reference.enclosure = res.data.url
      this.reference.file_name = res.data.file_name
    },
    //删除附件
    beforeremove(res, file, fileList) {
      this.reference.enclosure = ''
      this.reference.file_name = ''
      this.fileList = []
    },
    //删除论文
    beforeremoveLW(res, file, fileList) {
      this.reference.paper = ''
      this.reference.paper_name = ''
      this.fileListLW = []
    },
    //滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    // 点击提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getInfoExpert()
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //提交接口
    async getInfoExpert() {
      const {
        data: data
      } = await this.$http.post("info/expert", this.reference)
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$router.back()
    },
    //返回
    backProject() {
      this.$router.back()
    }
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
  }

  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    margin-bottom: 40px;
  }

  // 上传图片
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 66px;
    height: 66px;
    line-height: 66px;
    text-align: center;
  }

  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }

  /* // 上传文件 */
  .uploads {
    display: flex;

    .upload-demo {
      display: flex;
      align-items: center;

      .el-button {
        border-radius: 6px 0 0 6px;
      }

      /deep/ .el-upload-list {
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
        width: 421px;
        height: 32px;
        margin-top: 1px;

        .el-upload-list__item {
          margin: 3px 0;
        }
      }
    }

    .ticks {
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }

  //新的
  .uploads-box {
    position: relative;

    .upload-demo {
      align-items: center;

      .el-button {
        border-radius: 6px 0 0 6px;
      }

      .box {
        position: absolute;
        top: 1px;
        left: 80px;
        width: 421px;
        height: 32px;
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
      }
    }

    .ticks {
      position: absolute;
      top: -10px;
      left: 500px;
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }

  //上传文件ui el-upload-list el-upload-list--text
  /deep/ .el-upload-list {
    z-index: 9999;
    position: absolute;
    top: -5px;
    left: 80px;
    width: 410px;
    overflow: hidden;
  }
}
</style>